<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="items != null && keys != null">
    <EditDialog
      v-model="editDialog"
      :save-button-text="itemId === 'new' ? $t('create') : $t('save')"
      :title="`${itemId === 'new' ? $t('nnew') : $t('edit')} Repository`"
      @save="loadItems()"
      :max-width="450"
    >
      <template v-slot:form="{ onSave, onError, needSave, needReset }">
        <RepositoryForm
          :project-id="projectId"
          :item-id="itemId"
          @save="onSave"
          @error="onError"
          :need-save="needSave"
          :need-reset="needReset"
        />
      </template>
    </EditDialog>

    <ObjectRefsDialog
      object-title="repository"
      :object-refs="itemRefs"
      :project-id="projectId"
      v-model="itemRefsDialog"
    />

    <YesNoDialog
      :title="$t('deleteRepository')"
      :text="$t('askDeleteRepo')"
      v-model="deleteItemDialog"
      @yes="deleteItem(itemId)"
    />

    <YesNoDialog
      :title="$t('deleteN', { count: selectedItems.length })"
      :text="$t('bulkDeleteConfirm', { count: selectedItems.length })"
      v-model="bulkDeleteDialog"
      @yes="bulkDelete()"
    />

    <v-toolbar flat >
      <v-app-bar-nav-icon @click="showDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('repositories') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <ListToolbar
        :value="searchText"
        :selection-count="selectedItems.length"
        @search="onSearchInput($event)"
        @bulk-delete="askBulkDelete()"
        class="mr-3"
      />
      <v-btn
        color="primary"
        @click="editItem('new')"
        v-if="can(USER_PERMISSIONS.manageProjectResources)"
      >{{ $t('newRepository') }}</v-btn>
    </v-toolbar>

    <v-divider />

    <v-data-table
      v-model="selectedItems"
      show-select
      item-key="id"
      :headers="headers"
      :items="items"
      :search="searchText"
      :custom-filter="filterByName"
      class="mt-4"
      :items-per-page="25"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
      :no-data-text="searchText ? $t('noMatches') : $t('noItems')"
    >
      <template v-slot:item.git_url="{ item }">
        {{ item.git_url }}
        <code v-if="!isLocalRepositoryPath(item.git_url)">{{ item.git_branch }}</code>
      </template>

      <template v-slot:item.ssh_key_id="{ item }">
        {{ keys.find((k) => k.id === item.ssh_key_id).name }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn-toggle dense :value-comparator="() => false">
          <v-btn @click="askDeleteItem(item.id)">
            <ZpIcon name="trash-2" :size="18" />
          </v-btn>
          <v-btn @click="editItem(item.id)">
            <ZpIcon name="pencil" :size="18" />
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-data-table>
  </div>

</template>
<script>
import ItemListPageBase from '@/components/ItemListPageBase';
import RepositoryForm from '@/components/RepositoryForm.vue';
import { isLocalRepositoryPath } from '@/lib/repositoryUrl';
import axios from 'axios';
import ListToolbar from '@/components/ListToolbar.vue';

export default {
  mixins: [ItemListPageBase],
  components: { RepositoryForm, ListToolbar },
  data() {
    return {
      keys: null,
    };
  },

  async created() {
    this.keys = (await axios({
      method: 'get',
      url: `/api/project/${this.projectId}/keys`,
      responseType: 'json',
    })).data;
  },

  methods: {
    isLocalRepositoryPath,

    getHeaders() {
      return [{
        text: this.$i18n.t('name'),
        value: 'name',
        width: '25%',
      },
      {
        text: this.$i18n.t('gitUrl'),
        value: 'git_url',
        width: '50%',
      },
      {
        text: this.$i18n.t('sshKey'),
        value: 'ssh_key_id',
        width: '25%',
      },
      {
        text: this.$i18n.t('actions'),
        value: 'actions',
        sortable: false,
      }];
    },
    getItemsUrl() {
      return `/api/project/${this.projectId}/repositories`;
    },
    getSingleItemUrl() {
      return `/api/project/${this.projectId}/repositories/${this.itemId}`;
    },
    getEventName() {
      return 'i-repositories';
    },
  },
};
</script>
